import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Tooltip } from 'reactstrap';
function SidebarTooltip(props) {
    const { index, id, isActive } = props;
    const [tooltipOpen, setTooltipOpen] = useState(false);

    const toggle = () => setTooltipOpen(!tooltipOpen);

    return (
        <>
            <NavLink to={index.link} id={'Tooltip-' + id} key={id}
                activeclassname="active" className={`${isActive ? "sidebar-link-active" : "sidebar-link"} `}><span className="">
                    {index.icon}
                </span>
                <h1 className={`mb-0 title-font-700 fs-32 text-nowrap ${isActive && "title-none"}`}>{index.title}
                </h1></NavLink>
            {
                isActive &&
                <Tooltip
                    placement="right"
                    isOpen={tooltipOpen}
                    target={'Tooltip-' + id}
                    toggle={toggle}
                >
                    <span className="fs-3 px-2 py-1 title-font-500 border-0">{index.title}</span>
                </Tooltip>
            }

        </>
    );
}

export default SidebarTooltip